import { render } from "./SmSidebarModalCreateComponent.vue?vue&type=template&id=3b9216cc"
import script from "./SmSidebarModalCreateComponent.vue?vue&type=script&lang=js"
export * from "./SmSidebarModalCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmSidebarModalCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b9216cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b9216cc', __exports__)) {
    api.reload('3b9216cc', __exports__)
  }
  
  module.hot.accept("./SmSidebarModalCreateComponent.vue?vue&type=template&id=3b9216cc", () => {
    api.rerender('3b9216cc', render)
  })

}


export default __exports__